// @ts-expect-error untyped
import TeamSelect from 'ui-addon-teams/components/TeamSelect';
// @ts-expect-error untyped
import ResolveReferences from 'reference-resolvers/ResolveReferences';
import { useMemo } from 'react';
// @ts-expect-error untyped
import { HIERARCHICAL_TEAM } from 'reference-resolvers/constants/ReferenceObjectTypes';
import { List } from 'immutable';
// @ts-expect-error untyped
import { isError, isLoading } from 'reference-resolvers/utils';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error untyped
import { jsx as _jsx } from "react/jsx-runtime";
const TeamValueComponent = count => () => {
  if (count > 0) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.myTeam.filters.teamsValues",
      options: {
        count
      }
    });
  }
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "learningCenter.myTeam.filters.teams"
  });
};
function getTeamsList(teamsResolver) {
  if (isLoading(teamsResolver) || isError(teamsResolver)) {
    return List([]);
  }
  return teamsResolver.toList();
}
const Select = ({
  teamsResolver,
  onChange,
  selectedTeams = []
}) => {
  const teamIdsList = useMemo(() => List(selectedTeams), [selectedTeams]);
  const teamOptions = getTeamsList(teamsResolver);
  return /*#__PURE__*/_jsx(TeamSelect, {
    ButtonContent: TeamValueComponent(selectedTeams.length),
    buttonUse: "transparent",
    "data-test-id": "team-filter-select",
    minimumSearchCount: 3,
    multi: true,
    onChange: evt => {
      const newSelectedTeams = evt.target.value.toJS().map(Number);
      onChange === null || onChange === void 0 || onChange(newSelectedTeams);
    },
    placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.myTeam.filters.teams"
    }),
    teams: teamOptions,
    value: teamIdsList
  });
};
const mapResolversToProps = refResolvers => {
  return {
    teamsResolver: refResolvers[HIERARCHICAL_TEAM].all()
  };
};
const TeamFilter = ResolveReferences(mapResolversToProps)(Select);
export default TeamFilter;